<div class="d-inline-flex">
  <ncp-button
    #addProcedureButton
    [options]="btnSPOptions()"
  >
    @if(!btnSPOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.devices.surgical_sterilization.src"
        width="18"
        height="18"
        alt="Add Surgical Procedure"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="procedures_form"
      name="procedures_form"
      [formGroup]="form"
      #spFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #procedureDesc [(options)]="procedureDescDDOptions" />
      <ncp-date #procedureDate [(options)]="procedureDateOptions" />
    </form>
  </ncp-modal>
</div>
